// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"1aa85483","453":"ae364084","528":"5fa40082"}[chunkId] + ".chunk.js";
};